import { Subject } from "./types";

/** Backend subject from API (snake_case) */
export interface BackendSubject {
  id: number;
  name: string;
  discipline_cipher?: string;
  discipline_code?: string;
  credit_amount?: number;
  description?: string;
  specialities?: string[];
  prerequisite_ids?: number[];
  related_subject_ids?: number[];
}

/** Map backend subject to frontend Subject format */
export function mapBackendToSubject(row: BackendSubject): Subject {
  return {
    id: String(row.id),
    name: row.name,
    disciplineCipher: row.discipline_cipher ?? "",
    disciplineCode: row.discipline_code ?? "",
    creditAmount: row.credit_amount ?? 0,
    description: row.description ?? "",
    specialities: Array.isArray(row.specialities) ? row.specialities : [],
    prerequisiteIds: (row.prerequisite_ids ?? []).map(String),
    relatedSubjectIds: (row.related_subject_ids ?? []).map(String),
  };
}
